/**
 * @generated SignedSource<<a778df4773a125335128c8244447efe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MentalHealthTopics = "ADJUSTMENT_DISORDER" | "ANGER" | "ANXIETY" | "ASSERTIVENESS" | "ATTENTION_AND_HYPERACTIVITY_CONCERNS" | "BEING_A_CARER" | "BEING_A_MANAGER_FOR_THE_FIRST_TIME" | "BEING_A_MANAGER_ISSUES" | "BEING_PROMOTED" | "BEREAVEMENT_REACTION" | "BI_POLAR_DEPRESSION" | "BODY_DYSMORPHIA" | "BREAKING_HABITS" | "BUILDING_NEW_RELATIONSHIPS" | "BULLYING" | "BURNOUT" | "CAREER_CHANGE" | "CHRONIC_PAIN" | "COMMUNICATION_ISSUES_AT_WORK" | "COMPULSIVE_BUYING" | "CULTURAL_IDENTITY" | "DEALING_WITH_DEBT" | "DEALING_WITH_FINANCIAL_WORRY" | "DEALING_WITH_UNCERTAINTY_AT_WORK" | "DECISION_MAKING" | "DEPRESSION" | "DIVERSITY_EQUITY_INCLUSION" | "DIVERSITY_EQUITY_INCLUSION_AT_WORK" | "EATING_WEIGHT_ISSUES" | "FEELING_DEPRESSED_LOW_MOOD" | "FINANCIAL_ANXIETY" | "FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS" | "FINANCIAL_STABILITY" | "FINDING_PURPOSE" | "GAMBLING_NON_SUBSTANCE_ADDICTIONS" | "GENERALIZED_ANXIETY_DISORDER" | "GIVING_RECEIVING_FEEDBACK" | "GRIEF_LOSS" | "HEALTH_ANXIETY" | "HELP_WITH_ADOPTING_HEALTHIER_HABITS" | "HELP_WITH_WORK_RELATED_ISSUE" | "IMPOSTER_SYNDROME" | "IMPROVING_MY_RELATIONSHIPS" | "INDECISION" | "INSOMNIA" | "INTERPERSONAL_ISSUES" | "LACK_OF_CONFIDENCE" | "LACK_OF_EXERCISE" | "LONG_TERM_HEALTH_CONDITION" | "MANAGING_CONFLICT" | "MEDICALLY_UNEXPLAINED_SYMPTOMS" | "MINDFULNESS_MEDITATION" | "NAVIGATING_CONFLICT" | "OBSESSIONS_AND_COMPULSIONS" | "OCD" | "OVERALL_WELLNESS" | "PANIC_DISORDER_WITHOUT_AGORAPHOBIA" | "PANIC_DISORDER_WITH_AGORAPHOBIA" | "PARENTING_CAREGIVING_FAMILY" | "PERFECTIONISM" | "PHOBIAS" | "PROCRASTINATION" | "PTSD" | "QUITTING_SMOKING" | "RECENT_PROMOTION" | "REMOTE_WORK_ISSUES" | "RUMINATION" | "SELF_ESTEEM" | "SERIOUS_MENTAL_ILLNESS" | "SEXUAL_DYSFUNCTION" | "SIGNIFICANT_OR_CHRONIC_STRESS" | "SKIN_PICKING" | "SLEEP_ISSUES" | "SOCIAL_ANXIETY" | "SPEAKING_IN_FRONT_OF_OTHERS" | "STRESS_AND_WORRY_AT_WORK" | "SUBSTANCE_ALCOHOL_USE_CONCERNS" | "TRAUMA" | "TRICHOTILLOMANIA" | "UNHAPPY_AT_WORK" | "WORK_LIFE_BALANCE" | "WORRY_ABOUT_BURNOUT" | "WORRY_ABOUT_PERFORMANCE_AT_WORK";
export type ResourceArea = "FITNESS" | "FOCUS" | "LEARN" | "LISTEN" | "MANAGE" | "MEDITATION" | "SLEEP" | "YOGA";
export type ResourceStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SUGGESTED";
export type ResourceTypeFilterBy = "ARTICLE" | "ASSET" | "AUDIO" | "CONTENT" | "COURSE" | "PODCAST" | "TALK" | "VIDEO" | "WORKSHEET";
export type ResourcesFilterBy = {
  area?: ReadonlyArray<ResourceArea> | null | undefined;
  featured?: boolean | null | undefined;
  status?: ReadonlyArray<ResourceStatus> | null | undefined;
  topics?: ReadonlyArray<MentalHealthTopics> | null | undefined;
  type?: ReadonlyArray<ResourceTypeFilterBy> | null | undefined;
};
export type PopularResourcesQuery$variables = {
  filterBy?: ResourcesFilterBy | null | undefined;
  maxResources?: number | null | undefined;
};
export type PopularResourcesQuery$data = {
  readonly popularResources: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ResourceCard_resource">;
    }>;
  };
};
export type PopularResourcesQuery = {
  response: PopularResourcesQuery$data;
  variables: PopularResourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxResources"
},
v2 = [
  {
    "kind": "Variable",
    "name": "filterBy",
    "variableName": "filterBy"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "maxResources"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopularResourcesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ResourceConnection",
        "kind": "LinkedField",
        "name": "popularResources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resource",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ResourceCard_resource"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopularResourcesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ResourceConnection",
        "kind": "LinkedField",
        "name": "popularResources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Resource",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageCard",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "format",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFavourite",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c1799b3348600c97d57fe361e33f865c",
    "id": null,
    "metadata": {},
    "name": "PopularResourcesQuery",
    "operationKind": "query",
    "text": "query PopularResourcesQuery(\n  $maxResources: Int\n  $filterBy: ResourcesFilterBy\n) {\n  popularResources(first: $maxResources, filterBy: $filterBy) {\n    nodes {\n      id\n      ...ResourceCard_resource\n    }\n  }\n}\n\nfragment ResourceCard_resource on Resource {\n  imageCard\n  id\n  type\n  name\n  slug\n  format\n  isFavourite\n}\n"
  }
};
})();

(node as any).hash = "385485305b2f1b1daba111cd10d51479";

export default node;
